import type { RailItem } from '@clarix/shared-types';

/**
 * Rail items rendered before every app's contributed items. Identical
 * across all apps. Intentionally empty — each app owns its own landing
 * item (e.g. Projects' "Projects"), so there is no shared "Home" icon.
 * Kept as an extension point for any future global rail item.
 */
export const BASE_RAIL_TOP: readonly RailItem[] = [] as const;
